const theme = {
  id: 'bingo',
  primary: '#B5FE83',
  secondary: '#B5FE83', //Dark Blue
  background: '#FFB72B', //yellow
  third: '#FFE61B', // orange
  text: 'black',
};

export default theme;
